/* Cart Drawer Fix v27 — brute force open + native getCart refresh */
(function(){
  if(window.__cdf28)return;window.__cdf28=1;

  /* Fix close button SVG size — cart-drawer.css may load async */
  var fixStyle=document.createElement('style');
  fixStyle.textContent='.cart-drawer__close{position:absolute!important;top:-2px!important;right:0!important;width:54px!important;height:54px!important;padding:15px!important;z-index:10!important;overflow:hidden!important}.cart-drawer__close svg{display:block!important;width:24px!important;height:24px!important}';
  document.head.appendChild(fixStyle);

  function openDrawer(){
    var el=document.querySelector('cart-element[data-cart-drawer]');
    if(!el)return;

    /* Step 1: Render template if not loaded (gives us header, body, footer, close btn) */
    if(!el.isCartDrawerLoaded && typeof el.renderCartDrawer==='function'){
      el.renderCartDrawer(false);
    }

    /* Step 2: Force drawer visible with inline styles */
    el.style.cssText='position:fixed!important;right:0!important;top:0!important;bottom:0!important;left:auto!important;width:400px!important;max-width:95vw!important;z-index:99999!important;visibility:visible!important;opacity:1!important;content-visibility:visible!important;background:var(--bg,#fff)!important;overflow-y:auto!important;display:flex!important;flex-direction:column!important;transform:none!important;height:100%!important;box-shadow:-4px 0 20px rgba(0,0,0,0.15)!important;';

    /* Step 3: Add classes the theme expects */
    el.classList.add('is-open');
    el.classList.remove('cv-h');
    document.body.classList.add('js-drawer-open-cart');
    el.isCartDrawerOpen=true;

    /* Step 4: Use theme's native getCart to refresh content properly.
       Since isCartDrawerLoaded=true, it skips renderCartDrawer and goes
       straight to fetch → build() which updates items, totals, etc.
       build() calls openCartDrawer() but it returns early since isCartDrawerOpen=true. */
    if(typeof el.getCart==='function'){
      el.getCart();
    }

    /* Step 5: Set up close handler on the drawer's close button */
    setTimeout(function(){
      var closeBtn=el.querySelector('[data-cart-drawer-toggle]');
      if(closeBtn){
        closeBtn.addEventListener('click',function closeDrawer(ev){
          ev.preventDefault();
          el.style.cssText='';
          el.classList.remove('is-open');
          el.classList.add('cv-h');
          document.body.classList.remove('js-drawer-open-cart');
          el.isCartDrawerOpen=false;
          closeBtn.removeEventListener('click',closeDrawer);
        });
      }
    },200);
  }

  /* Capture click on add-to-cart buttons BEFORE Massy */
  document.addEventListener('click',function(e){
    var btn=e.target.closest(
      'button[name="add"], '+
      'button.product-form__submit, '+
      '.product-form button[type="submit"], '+
      'product-form button[type="submit"]'
    );
    if(!btn)return;

    var form=btn.closest('form[action*="/cart/add"], product-form form');
    if(!form)return;

    var cartEl=document.querySelector('cart-element[data-cart-drawer]');
    if(!cartEl)return;

    e.preventDefault();
    e.stopImmediatePropagation();

    btn.classList.add('is-loading');
    btn.setAttribute('disabled','true');

    var formData=new FormData(form);

    fetch(form.action||'/cart/add.js',{
      method:'POST',
      headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'},
      body:formData
    })
    .then(function(r){return r.json();})
    .then(function(data){
      btn.classList.remove('is-loading');
      btn.removeAttribute('disabled');

      if(data&&data.status){
        var pf=btn.closest('product-form');
        if(pf&&typeof pf.addToCartError==='function') pf.addToCartError(data);
        return;
      }

      openDrawer();
    })
    .catch(function(err){
      console.error('[CDF] error:',err);
      btn.classList.remove('is-loading');
      btn.removeAttribute('disabled');
    });

  },true);

  /* Patch ProductForm prototype */
  if(window.customElements){
    customElements.whenDefined('product-form').then(function(){
      var PF=customElements.get('product-form');
      if(!PF||!PF.prototype.addToCart)return;
      var orig=PF.prototype.addToCart;
      PF.prototype.addToCart=function(d,v){
        this.isCartDrawer=!!document.querySelector('cart-element[data-cart-drawer]');
        return orig.call(this,d,v||'');
      };
    });
  }
})();
